<div class="review-rate-container">
  <app-review-rate *ngFor="let eachOption of this.reviewOptionsList"
   [id]="eachOption.id"
   [color]="eachOption.color">
    <img [src]="eachOption.img" [alt]="eachOption.alt">
    <span class="review-rate-container__label mt-1">{{eachOption.label}}</span>
  </app-review-rate>
</div>